import { CategoryChip } from '../styles';
import { truncateString } from '../utils';
import { Ancor, Categories, NewsButton, NewsContainer, NewsTitle, Span } from './styles';

interface NewsProps {
  title: string;
  id: string;
  category: string[];
  image?: string;
}

const News = ({ title, id, category, image }: NewsProps) => {
  return (
    <Ancor href={id}>
      <NewsContainer image={image}>
        <NewsTitle>{truncateString(title, 34)}</NewsTitle>

        <Categories>
          {category.map((element, index) => (
            <CategoryChip
              key={index}
              variant="filled"
              color="primary"
              label={element}
              size="small"
              sx={{ maxWidth: '5rem', zIndex: '4', marginRight: '0.4rem' }}
            />
          ))}
        </Categories>

        <NewsButton href={`/blog/${id}`} data-cy="btn-view-more">
          Ver mas <Span>{' ->'}</Span>
        </NewsButton>
      </NewsContainer>
    </Ancor>
  );
};

export default News;
